// extracted by mini-css-extract-plugin
export default {"TextCell":"interactive-item-title-module__TextCell--tWzyY","Link":"interactive-item-title-module__Link--cmI_Q","is-disabled":"interactive-item-title-module__is-disabled--FA1mx"};